import "./styles/teamMember.css";


const TeamMember = (props) => {
    const { name, role, description, picture} = props;

    return (
        <div className="teamMemberContainer">
            <img src={picture} alt="teamMember" />
            <div className="teamMemberInfo">
                <h2>{name}</h2>
                <div className="role">{role}</div>
                <p>{description}</p>
            </div>
        </div>
    );
};

export default TeamMember;
